module.exports = __webpack_public_path__ + "static/scale-model-of-mud-island-river-park-in-memphis-tennessee-571324045add0651ad38141f626b792d.png";